import { Plus, X, Minus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/SessionInfoCard";

function BehaviorRow({ b, i, update, remove }) {
  return (
    <div className="rounded-lg border p-3 space-y-2" data-testid={`behavior-row-${i}`}>
      <div className="flex gap-2 items-center">
        <Input value={b.name} onChange={(e) => update({ name: e.target.value })} placeholder="Behavior (e.g. Tantrum)" className="h-9" data-testid={`behavior-name-input-${i}`} />
        <div className="flex items-center rounded-md border h-9 shrink-0">
          <button className="px-2 h-full hover:bg-muted" onClick={() => update({ frequency: Math.max(0, b.frequency - 1) })} data-testid={`behavior-decrement-${i}`}><Minus className="h-3.5 w-3.5" /></button>
          <input type="number" inputMode="numeric" min={0} value={b.frequency} onFocus={(e) => e.target.select()}
            onChange={(e) => update({ frequency: Math.max(0, Math.min(9999, parseInt(e.target.value, 10) || 0)) })}
            className="w-12 h-full text-center font-mono text-sm bg-transparent outline-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none"
            aria-label="Frequency" data-testid={`behavior-frequency-${i}`} />
          <button className="px-2 h-full hover:bg-muted" onClick={() => update({ frequency: b.frequency + 1 })} data-testid={`behavior-increment-${i}`}><Plus className="h-3.5 w-3.5" /></button>
        </div>
        <Button variant="ghost" size="icon" className="h-9 w-9 shrink-0" onClick={remove} data-testid={`behavior-remove-${i}`}><X className="h-4 w-4" /></Button>
      </div>
      <div className="grid grid-cols-[110px_1fr] gap-2">
        <Input value={b.duration} onChange={(e) => update({ duration: e.target.value })} placeholder="Duration" className="h-9 text-sm" data-testid={`behavior-duration-input-${i}`} />
        <Input value={b.notes} onChange={(e) => update({ notes: e.target.value })} placeholder="Antecedent / consequence notes" className="h-9 text-sm" data-testid={`behavior-notes-input-${i}`} />
      </div>
    </div>
  );
}

export function BehaviorsCard({ behaviors, onChange }) {
  const update = (i, patch) => onChange(behaviors.map((b, j) => (j === i ? { ...b, ...patch } : b)));
  const add = () => onChange([...behaviors, { name: "", frequency: 0, duration: "", notes: "" }]);
  return (
    <Card title="Behavior data" action={<Button size="sm" variant="ghost" onClick={add} data-testid="add-behavior-button"><Plus className="h-4 w-4 mr-1" />Add</Button>}>
      {behaviors.length === 0 ? (
        <p className="text-sm text-slate-500">No behaviors tracked for this session.</p>
      ) : (
        <div className="space-y-3">
          {behaviors.map((b, i) => <BehaviorRow key={i} b={b} i={i} update={(p) => update(i, p)} remove={() => onChange(behaviors.filter((_, j) => j !== i))} />)}
        </div>
      )}
    </Card>
  );
}
